import { useQuery } from '@hooks/reactQuery';

import { getPortalProjectsStatuses } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_PROJECTS_STATUSES } from '@constants/queryKeys';

interface IUseQueryPortalProjectStatusesReturned {
	portalProjectsStatuses: Array<TSelectOption>;
	isLoadingPortalProjectsStatuses: boolean;
}

export const useQueryPortalProjectStatuses = (): IUseQueryPortalProjectStatusesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_PROJECTS_STATUSES],
		queryFn: extractQueryParams(getPortalProjectsStatuses),
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalProjectsStatuses: data || [],
		isLoadingPortalProjectsStatuses: isLoading || isFetching,
	};
};
